import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@mui/styles';
import { useMediaQuery, Grid2 as Grid, Typography, Button } from '@mui/material';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';

const useStyles = makeStyles(() => ({
  image: {
    maxWidth: 420,
  },
}));

const OneStopSolution = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
      <Grid
        container
        justify="space-between"
        spacing={isMd ? 4 : 2}
        direction={isMd ? 'row' : 'column-reverse'}
      >
        <Grid
          item
          container
          alignItems="center"
          justify="flex-start"
          size={{ xs: 12, md: 6 }}
          data-aos={'fade-up'}
        >
          <div>
            <SectionHeader
              title="One Stop eCommerce Solution"
              subtitle=" "
              align="left"
              disableGutter
              subtitleProps={{
                color: 'textPrimary',
                variant: 'body1',
              }}
            />
            <Typography
              variant="body1"
              color="textPrimary"
              align="justify"
              sx={{ display: 'block', marginBottom: theme => theme.spacing(2) }}
              className=""
            >
              In this Digital Era the big business houses have transformed themselves to be online.
            </Typography>
            <Typography
              variant="body1"
              align="justify"
              sx={{ display: 'block', marginBottom: theme => theme.spacing(2) }}
              color="textPrimary"
              className=""
            >
              The marketplaces are dawning their ways and creating a kind of monopoly that is eating into the revenues of small and medium size businesses.
            </Typography>
            <Typography
              variant="body1"
              align="justify"
              sx={{ display: 'block', marginBottom: theme => theme.spacing(2) }}
              color="textPrimary"
              className=""
            >
              Most of the hold back to go digital or go online is the fear of unknowns and technology known how.
            </Typography>
            <Typography
              variant="body1"
              align="justify"
              sx={{ display: 'block', marginBottom: theme => theme.spacing(2) }}
              color="textPrimary"
              className=""
            >
              Mperito is here to be your technology partner making your journey to launch your branded ecommerce or mobile app easy. We ensure you and your team is fully equipped to operate online commerce like pro.
            </Typography>
            <Button variant="contained" color="secondary" size="large"
                            sx={{
                                padding: { xs: '8px 16px', md: '16px 32px'},
                                fontSize: { xs: '1rem', md:'1.2rem'},
                                borderRadius: { xs:'20px', md:'40px'},
                                boxShadow: 4,
                            }} href="/#home-contact">
                            Contact Us
                        </Button>
            {/* <Typography
              variant="h6"
              sx={{ display: 'block', marginBottom: theme => theme.spacing(2) }} 
              color="textPrimary"
              className=""
            >
              That was the starting point of MindsClik…
            </Typography> */}
          </div>
        </Grid>
        <Grid
          item
          container
          justify={isMd ? 'flex-end' : 'flex-start'}
          alignItems="center"
          size={{ xs: 12, md: 6 }}
          data-aos={'fade-up'}
        >
          <Image
            src="/assets/images/about/story.png"
            alt="One Stop eCommerce Solution"
            className={classes.image}
          />
        </Grid>
      </Grid>
    </div>
  );
};

OneStopSolution.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default OneStopSolution;
